module.exports = __webpack_public_path__ + "static/media/index.af2a312d.mjs";